module.exports = __webpack_public_path__ + "img/prize.5777f8d9.png";